import { agentProfileIdSchema } from "../protocol/profile.js";
import { daemonServiceLaneSchema } from "./service-contract.js";
import { conversationPolicySchema } from "./conversation-contract.js";
import { runtimeAgentControllerConversationIdMappingSpecSchema, runtimeAgentControllerLaunchContractSchema, runtimeStreamingModeSchema, runtimeTransportModeSchema } from "./controller-contract.js";
import { skippedDaemonProfileSchema } from "./control-plane.js";
import { CURRENT_DAEMON_EXECUTION_CONTRACT_EPOCH } from "./runtime-transport.js";
import { agentControllerCollaborationModeSchema } from "../agent-controller-collaboration-mode.js";
import { agentControllerPermissionModeSchema } from "../agent-controller-permission-mode.js";
import { openCodePermissionConfigSchema } from "../open-code-permission.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/route-catalog-cache.ts
const DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_VERSION = 4;
const DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_NAME = "openmeld-daemon-route-catalog-cache-v4";
const cachedDaemonRouteConfigSchema = z$1.strictObject({
	agentControllerRef: z$1.string().trim().min(1),
	bindingId: z$1.string().trim().min(1).optional(),
	agentControllerCollaborationMode: agentControllerCollaborationModeSchema.optional(),
	agentControllerPermissionMode: agentControllerPermissionModeSchema.optional(),
	configurationRevision: z$1.number().int().positive().optional(),
	contextIdMappingSpec: runtimeAgentControllerConversationIdMappingSpecSchema,
	conversationPolicy: conversationPolicySchema.optional(),
	openCodePermission: openCodePermissionConfigSchema.optional(),
	launchContract: runtimeAgentControllerLaunchContractSchema.nullable().optional(),
	profileId: agentProfileIdSchema,
	streamingMode: runtimeStreamingModeSchema,
	transportMode: runtimeTransportModeSchema,
	openMeldServiceRuntimeId: z$1.string().trim().min(1).optional()
});
const daemonRouteCatalogCacheBodySchema = z$1.strictObject({
	cachedAt: z$1.iso.datetime({ offset: true }),
	runtimeContractEpoch: z$1.literal(CURRENT_DAEMON_EXECUTION_CONTRACT_EPOCH),
	ownerUserId: z$1.string().trim().min(1),
	lane: daemonServiceLaneSchema,
	serviceBundleId: z$1.string().trim().min(1),
	profileIds: z$1.array(agentProfileIdSchema),
	routes: z$1.array(cachedDaemonRouteConfigSchema),
	skippedProfiles: z$1.array(skippedDaemonProfileSchema)
});
const daemonRouteCatalogCacheSchema = z$1.discriminatedUnion("v", [
	daemonRouteCatalogCacheBodySchema.extend({
		v: z$1.literal(2),
		schema: z$1.literal("openmeld-daemon-route-catalog-cache-v2")
	}),
	daemonRouteCatalogCacheBodySchema.extend({
		v: z$1.literal(3),
		schema: z$1.literal("openmeld-daemon-route-catalog-cache-v3")
	}),
	daemonRouteCatalogCacheBodySchema.extend({
		v: z$1.literal(4),
		schema: z$1.literal(DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_NAME)
	})
]).superRefine((value, ctx) => {
	const routeIds = new Set(value.routes.map((route) => route.profileId));
	for (const profileId of value.profileIds) if (!routeIds.has(profileId)) ctx.addIssue({
		code: "custom",
		message: "route catalog cache profileIds must match routes",
		path: ["profileIds"]
	});
});
//#endregion
export { DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_NAME, DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_VERSION, cachedDaemonRouteConfigSchema, daemonRouteCatalogCacheSchema };

//# sourceMappingURL=route-catalog-cache.js.map